import { Injectable, inject } from '@angular/core';
import { PlatformService } from './platform.service';
import { Hooks, register } from 'register-service-worker';
import {BehaviorSubject, fromEvent} from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PwaService {
  private _platform = inject(PlatformService);


  public isEnabled$ = new BehaviorSubject<boolean>(false);

  private _deferredPrompt = null;
  private _isEnabled = null;

  constructor() {
    this._beforeInstallPrompt();
  }

  get isEnabled(): boolean {
    return this._isEnabled;
  }

  public get deferredPrompt() {
    return this._deferredPrompt;
  }

  private _beforeInstallPrompt() {
    if (this._platform.isBrowser) {
      fromEvent(window, 'beforeinstallprompt').subscribe((e: any) => {
        e.preventDefault();
        this._deferredPrompt = e;
        this.isEnabled$.next(true);
        this._isEnabled = true;
      });
    }
  }

  /**
   * Install PWA app
   */
  public addAppToHomeScreen() {
    this._deferredPrompt.prompt();
    this._deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
        this.isEnabled$.next(false);
        this._isEnabled = false;
      } else {
        console.log('User dismissed the A2HS prompt');
        this.isEnabled$.next(true);
        this._isEnabled = true;
      }
    });
  }

  /**
   * Register Service Worker
   */
   public registerServiceWorker(): void {
    if (!this._platform.isBrowser || !environment.production) { return; }
    const serviceWorkerPath = `/sw.js`
    const options: Hooks = {
      registrationOptions: { scope: './' },
      ready: (registration) => {
        console.log('Service worker is active.');
      },
      registered: (registration) => {
      },
      cached: (registration) => {
      },
      updatefound: (registration) => {
      },
      updated: (registration) => {
      },
      offline: () => {
        console.error('No internet connection found. App is running in offline mode.')
      },
      error: (error) => {
        console.error('Error during service worker registration:', error)
      }
    }
    register(serviceWorkerPath, options);
  }

}
